import $ from 'jquery';

import AccordionRow from './accordionRow';

class Accordion {
  constructor(element){
    this.$el = $(element);
    this.rows = [];
    this.$el.children().children('.accordion-row, .accordion-table-row').each((index, value) => {
      this.rows.push(new AccordionRow(value));
    });
  }
}

$('.accordion-component').each((index, element) => {
  new Accordion(element);
});
